import React from 'react';
import Select from 'react-select';
import { Field } from 'formik';
import './dropdown.scss';

const customStyles = {
    control: (provided) => ({
        ...provided,
        borderRadius: '4px',
        color: '#24272b',
        border: 'none',
    }),
    menu: (provided) => ({
        ...provided,
        zIndex: 2,
    }),
    option: (provided, state) => ({
        ...provided,
        color: state.isSelected ? 'white' : '#292a2a',
        fontSize: '14px',
        backgroundColor: state.isSelected ? '#0047ba' : 'initial',
        zIndex: 2,
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#000000',
        fontSize: '1rem',
    }),
    indicatorSeparator: (provided) => ({
        ...provided,
        display: 'none',
    }),
    singleValue: (provided) => ({
        ...provided,
        fontSize: '1rem',

    }),
    menu: (provided) => ({
        ...provided,
        textAlign: 'left',
    }),
};

export default ({ name, placeholder, data, searchDropDown,searchable, onChangeHandler, disabled, onWishListChangeHandler }) => {
    return (
        <div>
            <Select
                className='custom-select-input'
                classNamePrefix='custom-select'
                name={name}
                value={data?.filter((option) => option.value === searchDropDown)}
                options={data}
                placeholder={placeholder}
                isDisabled={disabled?true:false}
                isSearchable={searchable || false}
                styles={customStyles}
                onChange={(data) => {
                    if (name === "dropDownWishList") {
                        onWishListChangeHandler(data)
                    } else {
                        onChangeHandler(data);
                    }
                }}
            />
        </div>
    );
};
